import { render, staticRenderFns } from "./IssuesExport.vue?vue&type=template&id=353e3bda&scoped=true"
import script from "./IssuesExport.vue?vue&type=script&lang=js"
export * from "./IssuesExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353e3bda",
  null
  
)

export default component.exports